<template>
  <div class="box">
    <h5>{{problem}}</h5>
    <img 
      class="img h5" 
      :src="img" 
      v-http2 
      v-img-size="'medium'" 
      v-img-error
      alt="pic"
    >
    <p>{{info}}</p>
  </div>
</template>

<script>
export default {
  name: 'EvaluateProblem',
  props: {
    problem: String,
    img: String,
    info: String,
  },
}
</script>

<style lang="scss" scoped>
.h5 { display: none }
.box {
  text-align: center;
  h5 {
    line-height: 1;
    font-family: 'Aspira Medium';
    font-weight: 500;
    font-size: 16px;
    color: #000;
  }
  p {
    line-height: 30px;
    font-size: 14px;
    font-family: 'Aspira Light';
    font-weight: 200;
    color: #000;
  }
}

// 移动端适配
@media screen and (max-width: 768px) {
  .h5 { display: inline-block }
  .box {
    h5 {
      font-family: 'Aspira Medium';
      font-weight: 500;
      font-size: rem(40);
      color: #000;
      padding: 0 rem(32);
    }
    p {
      font-family: 'Aspira Light';
      font-weight: 200;
      font-size: rem(32);
      color: #000;
    }
    .img {
      margin-top: rem(80);
      margin-bottom: rem(30);
      width: rem(120);
      height: rem(120);
      border-radius: 50%;
      object-fit: cover;
    }
  }
}
</style>
